import { createSelector } from 'reselect';

import { AppState } from '@mode/legacy/types-app-state';

export namespace SqlResultsSelectors {
  export const getSelectedQueryOffset = createSelector(
    (state: AppState) => state.sqlResults.paging[state.reportEditor.selectedQueryToken],
    (paging) => {
      if (paging) {
        return paging.offset;
      }

      return 0;
    }
  );

  export function createOffsetByRefIdSelector(refId: string) {
    return createSelector(
      (state: AppState) => state.sqlResults.paging[refId],
      (paging) => {
        if (paging) {
          return paging.offset;
        }
      }
    );
  }

  export function createPagingSelector(queryToken: string) {
    return (state: AppState) => state.sqlResults.paging[queryToken];
  }
}
